/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
export const dashboard_config = [
    {
        key: "customer_name",
        display : "Customer Name",
        val_key : "value",
        value : "Newell"
    },
    {
        key : "business_function",
        display : "Business Function",
        val_key : "value",
        value : "Email Classification"
    },
    {
        key : "geography",
        display : "Geography",
        val_key : "value",
        value : "North America"
    },
    {
        key : "mailbox",
        display : "Mailbox",
        val_key : "options",
        options : ["Outlook", "Gmail"],
    },
    {
        key : "destination_crm",
        display : "Destination CRM",
        val_key : "options",
        options : ["Service Now", "Salesforce"]
    },
    {
        key : "number_emails_received",
        display : "Number of Emails Received",
        val_key : "data",
        data : [
            {
                key: "Outlook",
                val_key : "data",
                data : [
                    {
                        key : "YTD",
                        val_key : "value",
                        value : 1000
                    },
                    {
                        key : "MTD",
                        val_key : "value",
                        value : 300
                    },
                    {
                        key : "WTD",
                        val_key : "value",
                        value : 100
                    },
                    {
                        key : "Today",
                        val_key : "value",
                        value : 25
                    }
                ]
            },
            {
                key : "Gmail",
                val_key : "data",
                data : [
                    {
                        key : "YTD",
                        val_key : "value",
                        value : 1100
                    },
                    {
                        key : "MTD",
                        val_key : "value",
                        value : 400
                    },
                    {
                        key : "WTD",
                        val_key : "value",
                        value : 150
                    },
                    {
                        key : "Today",
                        val_key : "value",
                        value : 50
                    }
                ]
            }
        ]
    },
    {
        key : "number_emails_to_ticket",
        display : "Number of Emails Converted to Case",
        val_key : "data",
        data : [
            {
                key : "Service Now",
                val_key : "data",
                data : [
                    {
                        key : "YTD",
                        val_key : "value",
                        value : 800
                    },
                    {
                        key : "MTD",
                        val_key : "value",
                        value : 500
                    },
                    {
                        key : "WTD",
                        val_key : "value",
                        value : 50
                    },
                    {
                        key : "Today",
                        val_key : "value",
                        value : 10
                    }
                ]
            },
            {
                key : "Salesforce",
                val_key : "data",
                data : [
                    {
                        key : "YTD",
                        val_key : "value",
                        value : 900
                    },
                    {
                        key : "MTD",
                        val_key : "value",
                        value : 400
                    },
                    {
                        key : "WTD",
                        val_key : "value",
                        value : 150
                    },
                    {
                        key : "Today",
                        val_key : "value",
                        value : 30
                    }
                ]
            }
        ]
    },
    {
        key : "cases_recommendation",
        display : "Cases with Recommendation provided",
        val_key : "data",
        data : [
            {
                key : "Service Now",
                val_key : "data",
                data : [
                    {
                        key : "YTD",
                        val_key : "value",
                        value : 800
                    },
                    {
                        key : "MTD",
                        val_key : "value",
                        value : 500
                    },
                    {
                        key : "WTD",
                        val_key : "value",
                        value : 50
                    },
                    {
                        key : "Today",
                        val_key : "value",
                        value : 10
                    }
                ]
            },
            {
                key : "Salesforce",
                val_key : "data",
                data : [
                    {
                        key : "YTD",
                        val_key : "value",
                        value : 900
                    },
                    {
                        key : "MTD",
                        val_key : "value",
                        value : 400
                    },
                    {
                        key : "WTD",
                        val_key : "value",
                        value : 150
                    },
                    {
                        key : "Today",
                        val_key : "value",
                        value : 30
                    }
                ]
            }
        ]
    }
]